<template>
  <div class="grid-y flex-grow divide-y">
    <div class="flex-shrink-0 container-tabs padding-horizontal-2 flex flex-row justify-between">
      <RouterTabs :tabs="tabs"/>
      <div class="flex flex-row items-center space-x-10">
        <span
          class="text-16px leading-18px text-primary font-bold cursor-pointer"
          v-b-modal="'create-order-by-partner'">
          Создать заказ
        </span>
        <span
          class="text-16px leading-18px text-primary font-bold cursor-pointer"
          v-b-modal="'change-customer'">
          Сменить автора объекта
        </span>
        <template v-if="$delve(object, 'blockingReason') === null">
          <span
            class="text-16px leading-18px text-danger font-bold cursor-pointer"
            v-b-modal="'disconnect'">
            Заблокировать объект
          </span>
        </template>
        <template v-else>
          <span
            class="text-16px leading-18px text-primary font-bold cursor-pointer"
            @click="unblock">
            Подключить объект
          </span>
        </template>
        <span
          class="text-16px leading-18px text-danger font-bold cursor-pointer"
          v-b-modal="'object-delete'">
          Удалить объект
        </span>
      </div>
    </div>
    <div class="cell auto flex">
      <div class="grid-x flex-grow">
        <div class="cell auto cell-block-y flex flex-grow">
          <router-view
            :id="id"
            :object="object">
          </router-view>
        </div>
      </div>
    </div>
    <ObjectBlockingModal @block="block"/>
    <ChangeCustomerModal @submit="onChangeCustomer"/>
    <ObjectDeleteModal @delete="objectDelete"/>
    <CreateOrderModal :object="object" />
  </div>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import RouterTabs from '@/components/RouterTabs.vue';
import ObjectBlockingModal from '@/components/Object/ObjectBlockingModal.vue';
import ChangeCustomerModal from '@/components/Object/ChangeCustomerModal.vue';
import ObjectDeleteModal from '@/components/Object/ObjectDeleteModal.vue';
import CreateOrderModal from '@/components/Object/CreateOrderModal.vue';

export default {
  components: {
    RouterTabs,
    ObjectBlockingModal,
    ChangeCustomerModal,
    ObjectDeleteModal,
    CreateOrderModal,
  },
  computed: {
    ...mapGetters({
      objectsGetter: 'objects/object',
    }),
    id() {
      return _.get(this.$route, 'params.id');
    },
    object() {
      if (this.id) {
        return this.objectsGetter(this.id);
      }
      return null;
    },
    tabs() {
      return [
        {
          title: 'Объект',
          push: {
            name: 'objects.details.info',
            params: {
              id: this.id,
            },
          },
        },
        {
          title: 'Действия с объектом',
          push: {
            name: 'objects.details.actions',
            params: {
              id: this.id,
            },
          },
        },
        {
          title: 'Заказы к объекту',
          push: {
            name: 'objects.details.orders',
            params: {
              id: this.id,
            },
          },
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      fetch: 'objects/ACT_FETCH_OBJECT',
      setBlocking: 'objects/ACT_SET_OBJECT_BLOCKING',
      assign: 'objects/ACT_OBJECT_ASSIGN_CUSTOMER',
      deleteObject: 'objects/ACT_DELETE_OBJECT',
    }),
    unblock() {
      this.setBlocking({
        id: this.id,
        reason: null,
      });
    },
    block(event) {
      this.setBlocking({
        id: this.id,
        reason: event,
      }).finally(() => {
        this.$bvModal.hide('disconnect-data');
      });
    },
    onChangeCustomer(event) {
      if (!event) return null;
      return this.assign({
        id: this.id,
        customer: event,
      }).then(() => {
        this.$bvModal.show('changed-customer');
      });
    },
    objectDelete() {
      this.deleteObject(this.id).then(() => {
        this.$router.push({
          name: 'objects',
        });
      });
    },
  },
  watch: {
    id: {
      handler(value) {
        if (value) {
          this.fetch(value);
        }
      },
      immediate: true,
    },
  },
};
</script>
